import React, {useEffect, useState} from 'react'
import Modal from '../Modal'
import NewModal from '../NewModal/NewModal'
import Form from '../Form/Form'
import FormInput from '../Inputs/FormInput/FormInput'
import {useForm} from 'react-hook-form'
import ApiSearchInput from './APISearchInput'
import {observer} from 'mobx-react'
import ModalsStore from '../Pages/Modals.store'
import AttentionGenerator from '../Form/AttentionGenerator'
import styled from "styled-components";
import CustomPrintModalStore from "../Modals/CustomPrintModal/store/CustomPrintModalStore";

const EditPatientModal2 = observer(() => {
    const NAME = `EditPatient2`
    const {data, methods} = ModalsStore.Modals[NAME]
    const [status, setStatus] = useState()
    const [error, setError] = useState({})
    const [phone, setPhone] = useState(data.initialForm.phone)
    const {errors, setValue, watch, register, handleSubmit} = useForm(
        {defaultValues: data.initialForm})
		
	const result_id = data.initialForm.id;


    return (
        <Modal mobile={true}>
            <NewModal
                completed={status}
                completedText={'Сохранено!'}
                completedButtonText={'Продолжить'}
                title={'Пациент'}
                closeHandler={_ => ModalsStore.closeModal(NAME)}
            >

                <Form submitHandler={handleSubmit(async (formData) => {
                    await methods.submit({...formData, phone})
                        .then(response => response !== 'success'
                            ? setError({
                                type: 'def',
                                message: 'Ой. У нас что-то пошло не так. Повторите свою попытку позже.'
                            })
                            : setStatus(true))

                })} submitButtonText={'Сохранить'}>
                    <StyledAttention>
                        <AttentionGenerator errors={{...errors, error}}/>

                    </StyledAttention>

                    {!data.disabledFields?.fio && <FormInput
                        important
                        hideIcon
                        reff={register({required: 'Введите ФИО'})}
                        name='fio'
                        title={'ФИО'}/>
                    }
                    {!data.disabledFields?.dob &&
                    <>
                        <FormInput
                            important
                            hideIcon
                            reff={register({required: 'Укажите дату рожедния'})}
                            name='dob'
                            type={'date'}
                            title={'Дата рождения'}/>
                    </>

                    }
                    {!data.disabledFields?.phone && <FormInput
                        hideIcon
                        useNumberFormat={true}
                        value={phone}
                        name={'phone'}
                        format='+7(###)###-##-##'
                        allowEmptyFormatting={true}
                        mask={'_'}
                        onChange={e => setPhone(e?.target?.value)}
                    >
                        Номер телефона
                    </FormInput>
                    }
					{!data.disabledFields?.phone && 
						<div className="form__option" style={{}}>
  						  <button onClick={() => {
							ModalsStore.closeModal(NAME)
							CustomPrintModalStore.showPrintModal('/api/v2/general/patients/forceaccess/'+result_id, 'POST')
						  }} style={{width: 170,backgroundColor: '#ccc',}}>Выдать доступ
						  </button>
					    </div>
                    }
					
					
                    {!data.disabledFields?.medBook &&
                    <FormInput hideIcon
                               reff={register()}
                               name='med_book'
                               title={'Мед. книжка'}/>
                    }
                    {!data.disabledFields?.address &&
                    <FormInput hideIcon

                               name='address'
                               reff={register()}
                               title={'Адрес'}/>
                    }

                    {!data.disabledFields?.medCenter &&

                    <ApiSearchInput
                        title={'Мед. центр'}
                        name={'med_id'}
                        reff={register()}
                        chooseHandler={id => setValue('med_id', id)}
                        initialValue={watch('med_name')}
                        orgType={'medcenter'}/>
                    }

                    {!data.disabledFields?.organization &&
                    <ApiSearchInput
                        title={'Организация'}
                        name={'org_id'}
                        reff={register()}
                        chooseHandler={id => setValue('org_id', id)}
                        initialValue={watch('org_name')}
                        orgType={'organization'}/>}
                    {!data.disabledFields?.jobName &&
                    <FormInput hideIcon
                               reff={register()}
                               name='job_name' title={'Цех - Отдел'}/>
                    }

                </Form>
            </NewModal>
        </Modal>
    )
})
const StyledAttention = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`

export default EditPatientModal2
